<template>
  <div class="fair-management-wrap">
    <modal
      @close-modal="showAddModal=false"
      v-if="showAddModal"
    >
      <add-new
        :locations="locations"
        :floors="floors"
        @close-modal="showAddModal=false"
        @get-locations="init"
      ></add-new>
    </modal>
    <div class="table">
      <div class="left-menu-wrap">
        <div class="add-button">
          <button @click="showAddModal=true">Add New</button>
        </div>
        <transition-group tag="div" class="left-menus" name="side-slide">
          <transition-group tag="div" name="side-slide" appear class="locations" key="1">
            <div
              v-for="(location, index) in locations"
              :class="selectedLocation.menu_name === location.menu_name? 'location selected' : 'location'"
              :key="index+1"
              @click="setSelectedLocation(location)"
            >
              {{location.menu_name}}
            </div>
          </transition-group>
          <div class="sub-locations" v-if="!isObjectEmpty(selectedLocation)" key="2">
            <div
              v-for="subLocation in selectedLocation.locations"
              :class="selectedSubLocation.loc_id === subLocation.loc_id? 'location selected' : 'location'" 
              :key="subLocation.loc_id"
              @click="setSelectedSubLocation(subLocation)"
            >
              {{subLocation.name}}
            </div>
          </div>
        </transition-group>
      </div>
      <div class="form">
        <div class="form-component" v-if="!isObjectEmpty(selectedSubLocation)">
          <add-or-edit-location
            :location="selectedSubLocation"
            :floors="floors"
            @get-locations="init"
          ></add-or-edit-location>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import AddNew from '../../components/admin/fair-management/AddNew'
import AddOrEditLocation from '../../components/admin/fair-management/AddOrEditLocation';
import AdminMixin from '../admin-pages/adminMixin.js'
export default {
  mixins: [
    AdminMixin
  ],
  components: {
    AddNew,
    AddOrEditLocation
  },
  data() {
    return {
      locations: [],
      floors: [],
      selectedLocation: {},
      selectedSubLocation: {},
      showAddModal: false
    };
  },
  mounted () {
    this.init();
  },
  methods: {
    async init () {
      this.startLoading();
        await this.getLocations();
        await this.getFloors();
      this.stopLoading();
    },
    async getLocations () {
      try {
        const res = await api.getAgendaLocations();
        let ungroupedLocations = res.data.result;
        this.locations = this.transformLocations(ungroupedLocations);
        this.selectedLocation = {};
        this.selectedSubLocation = {};
      } catch (error) {
        this.handleError(error);
      }
    },
    transformLocations (ungroupedLocations) {
      let intro = {menu_name: "Intro", ltp_code: 'intr', locations: []};
      let info = {menu_name: "Info", ltp_code: 'info', locations: []};
      let conferences = {menu_name: "Conferences", ltp_code: 'conf', locations: []};
      let floors = {menu_name: "Expo Floors", ltp_code: 'intl', locations: []};
      let booths = {menu_name: "Booths", ltp_code: 'bth', locations: []};

      for (let i = 0; i < ungroupedLocations.length; i++) {
        switch (ungroupedLocations[i].ltp_code) {
          case 'intr':
            intro.locations.push(ungroupedLocations[i]);
            break;
          case 'info':
            info.locations.push(ungroupedLocations[i]);
            break;
          case 'conf':
            conferences.locations.push(ungroupedLocations[i]);
            break;
          case 'intl':
            floors.locations.push(ungroupedLocations[i]);
            break;     
          case 'bth':
            booths.locations.push(ungroupedLocations[i]);
            break;
        }
      }

      return [intro, info, conferences, floors, booths];
    },
    async getFloors () {
      try {
        const res = await api.getFloors();
        this.floors = res.data.floors;
      } catch (error) {
        this.handleError(error);
      }
    },
    setSelectedLocation (location) {
      this.selectedLocation = location;
      this.selectedSubLocation = {};
    },
    setSelectedSubLocation (subLocation) {
      this.selectedSubLocation = subLocation;
    },
    isObjectEmpty (obj) {
      if (Object.keys(obj).length === 0 && obj.constructor === Object) return true;
      else return false;
    }
  }
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.fair-management-wrap {
  padding: 3% 5% 3% 3%;
  background-color: #e5e5e5;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.table {
  width: 100%;
  height: 80vh;
  display: flex;
  flex-direction: row;
  background: #343434;
  border-radius: 20px;
  overflow: hidden;
}
.left-menu-wrap {
  display: flex;
  flex-direction: column;
  color: white;
}
.form {
  flex-grow: 1;
  background: #FFF;
  overflow: auto;
}
.add-button {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}
.left-menus {
  overflow-y: auto;
  display: flex;
  flex-direction: row;
}
.locations {
  padding: 15px;
  width: 140px;
}
.sub-locations {
  padding: 15px;
  width: 200px;
}
.location, .location-item{
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
}
.location.selected {
  color: var(--button-color-blue);
}
.form-component {
  padding: 20px;
}
.buttons {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 100%;
}
.buttons button, .add-button button {
  cursor: pointer;
  white-space: nowrap;
  border: none;
  padding: 8px 23px;
  border-radius: 100px;
  font-size: 13px;
  margin: 0 10px;
  outline: none;
  height: 35px;
}
.delete-button {
  background: var(--button-color-bright-red);
  color: white;
}
.edit-button {
  background: var(--button-color-blue);
  color: white;
}

.side-slide-enter,
.side-slide-leave-to {
  width: 0;
}

.side-slide-enter-active,
.side-slide-leave-active {
  transition: width 0.3s ease-out;
}
</style>